import { denormalize, normalize } from 'normalizr'
import { useSelector } from 'react-redux'
import api from '../../api'
import { transmissionsSchema } from '../normalizr'
import { getPaginationHeaders, useAsyncAction } from '../utils'
import createSlice from '../create-slice'
import { getEntities } from './entities'

const transmissionsInitialState = {
  transmissionsIds: [],
  pageSize: 0,
  total: 0,
}

const transmissionsSlice = createSlice({
  name: 'transmissions',
  initialState: transmissionsInitialState,
  reducers: {
    setTransmissions: (state, { payload: { result, pageSize, total } }) => {
      state.transmissionsIds = result
      state.pageSize = pageSize
      state.total = total
    },
  },
})

const { actions } = transmissionsSlice

const selectState = state => state[transmissionsSlice.name]

export function useTransmissions() {
  const { transmissionsIds } = useSelector(selectState)
  const entities = useSelector(getEntities)
  const transmissions = denormalize(
    transmissionsIds,
    [transmissionsSchema],
    entities,
  )
  return transmissions
}

export function useTransmissionsPagination() {
  const { pageSize, total } = useSelector(selectState)
  return { pageSize, total }
}

export function fetchTransmissions(
  page,
  perPage,
  practiceId,
  deviceTypeId,
  deviceModelManufacturer,
  matched,
  showArchived,
  showReviewed,
  q,
  birthDate,
  medicalProviderId,
  officeLocationId,
) {
  return async dispatch => {
    const { body, headers } = await api.transmissions.list({
      page,
      perPage,
      practiceId,
      deviceTypeId,
      deviceModelManufacturer:
        deviceModelManufacturer !== 'all' ? deviceModelManufacturer : undefined,
      matched,
      includeArchived: showArchived,
      includeReviewed: showReviewed,
      q,
      birthDate,
      medicalProviderId,
      officeLocationId,
    })
    dispatch(
      actions.setTransmissions({
        ...normalize(body, [transmissionsSchema]),
        ...getPaginationHeaders(headers),
      }),
    )
  }
}

export function useFetchTransmissions({
  page,
  perPage,
  practiceId,
  deviceTypeId,
  deviceModelManufacturer,
  matched,
  showArchived,
  showReviewed,
  query,
  birthDate,
  medicalProviderId,
  officeLocationId,
} = {}) {
  return useAsyncAction(
    fetchTransmissions,
    page,
    perPage,
    practiceId,
    deviceTypeId,
    deviceModelManufacturer,
    matched,
    showArchived,
    showReviewed,
    query,
    birthDate,
    medicalProviderId,
    officeLocationId,
  )
}

export default transmissionsSlice
